import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import LanguageSwitcher from "./LanguageSwitcher";

export default function LandingNav() {
  const { t } = useTranslation("navbar");
  return (
    <nav className="landing-nav" aria-label={t("primaryNav")}>
      <Link to="/" className="landing-nav-brand">
        <Logo size={20} className="landing-nav-icon" />
        <span>pikra</span>
      </Link>
      <div className="landing-nav-links">
        <a href="#value">{t("howItWorks")}</a>
        <a href="#integra">Integra</a>
        <a href="#faq">{t("faq")}</a>
        <Link to="/validate">{t("validate")}</Link>
        <LanguageSwitcher />
        <a href="#demo-form" className="landing-nav-btn">Solicitar demo</a>
      </div>
    </nav>
  );
}
